import { render, staticRenderFns } from "./Vente.vue?vue&type=template&id=392c8622"
import script from "./Vente.vue?vue&type=script&lang=js"
export * from "./Vente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports